module.exports = __webpack_public_path__ + "a7f057276ebaa7ed96f4eeb309760731.mp4";